<template>
  <div>
    <a
        class="rich-link"
        rel="noopener noreferrer"
        :href="url"
        :target="urlHandling === 'new-tab' ? '_blank' : '_self'"
    >
      <arrow-right class="rich-link-icon" v-if="!urlPreviewOptions.image"/>
      <span class="rich-link-title">{{ formattedTitle }}</span>
      <div class="link-preview">
        <div class="preview-image" v-if="urlPreviewOptions.image">
          <img :src="urlPreviewOptions.image" alt="Preview" />
        </div>
        <div>
        </div>
        <div class="preview-info">
          <h3 v-if="urlPreviewOptions.title" class="preview-title">{{ urlPreviewOptions.title }}</h3>
          <p v-if="urlPreviewOptions.description" class="preview-description">{{ urlPreviewOptions.description }}</p>
        </div>
      </div>
    </a>
  </div>
</template>

<script>
import { getLinkPreview } from 'link-preview-js'
import ArrowRight from 'vue-material-design-icons/ArrowRight.vue'

export default {
  components: {
    ArrowRight
  },
  props: {
    url: {
      type: String,
      required: true
    },
    urlHandling: {
      type: String,
      required: true
    },
    urlText: {
      type: String,
      default: ''
    },
    urlPreview: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      urlPreviewOptions: {
        title: '',
        description: '',
        image: ''
      },
      loading: true
    }
  },
  computed: {
    formattedTitle () {
      if (this.urlPreview && this.urlPreviewOptions.title && this.urlPreviewOptions.title.length > 0) {
        return this.urlPreviewOptions.title
      }

      return this.urlText ? this.urlText : this.url
    }
  },
  methods: {
    async fetchUrlPreview () {
      try {
        const preview = await getLinkPreview(this.url)
        this.urlPreviewOptions.title = preview.title || ''
        this.urlPreviewOptions.description = preview.description || ''
        this.urlPreviewOptions.image = preview.images.length ? preview.images[0] : ''
      } catch (error) {
        console.error('Error fetching URL preview:', error)
      } finally {
        this.loading = false
      }
    },
    handleLinkClick (e) {
      e.preventDefault()
      if (this.urlHandling === 'new-tab') {
        window.open(this.url, '_blank') // Open in a new tab
      } else if (this.urlHandling === 'new-window') {
        window.open(this.url, '_blank', 'height=600,width=800') // Open in a new window with specified dimensions
      } else {
        window.location.href = this.url // Open in the same tab
      }
    }
  },
  mounted () {
    if (this.urlPreview) {
      this.fetchUrlPreview()
    }
  }
}
</script>

<style lang="sass" scoped>
@import '@/style/mixins'

.rich-link
  @include reset
  display: flex
  text-decoration: none
  line-height: 24px
  color: var(--text-primary)
  border: var(--border)
  border-radius: 40px
  padding: 8px 12px
  cursor: pointer
  justify-content: space-between
  align-items: center
  flex: 1

  &[href]
    color: var(--accent)

.rich-link-title
  flex: 1
  text-align: center

.preview-image
  max-width: 100px
  max-height: 80px
  padding: 10px

.link-preview
  font-size: 12px

.rich-link-icon
  margin-top: 5px
</style>
